import { useReducer, useEffect, useState } from 'react';
import { SIZE, SIZES, BREAKPOINT } from '../theme/metrics'

function getBreakpoint(windowWidth) {
	if(windowWidth){
		for (let i = SIZES.length - 1; i >= 0; --i) {
			if(windowWidth >= BREAKPOINT[SIZES[i]]){
				return SIZES[i];
			}
		}

		return SIZE.small;
	}

	return null;
}

function getWidth(){
	if(typeof window !== 'undefined'){
		return window.innerWidth;
	}

	return null;
}

let throttleTimeout = null;

export function useWindowWidth(wait=100) {
	const [windowWidth, setWindowWidth] = useState(getWidth());
	const [breakpoint, setBreakpoint] = useState(getBreakpoint(getWidth()));
	
	const update = () => {
		throttleTimeout = null;
		setWindowWidth(getWidth());
		setBreakpoint(getBreakpoint(getWidth()));
	}


	useEffect(() => {
		const change = () => {
			if (wait) {
				if (throttleTimeout === null) {
					throttleTimeout = setTimeout(update, wait)
				}
			} else {
				update()
			}
		}
		
		if(typeof window !== 'undefined'){
			window.addEventListener('resize', change);
			return () => {
				window.removeEventListener('resize', change);
			};
		}
		else{
			return null;
		}
	});

	

	return [windowWidth, breakpoint];
}